// extracted by mini-css-extract-plugin
export default {"ticker__wrapper":"DynamicBanner_ticker__wrapper__OEopo","ticker__text":"DynamicBanner_ticker__text__+QHXc","scroll-left":"DynamicBanner_scroll-left__7KX-g"};